import { RequireAuth, RequireAnonymous } from '../components/Routes';
import Dashboard from '../screens/Dashboard';
import SignIn from '../screens/SignIn';
import SignInForm from '../screens/SignIn/Form';
import SignInSituation from '../screens/SignIn/Situation';
import SignUpProfessional from '../screens/SignUp/Professional';
import ProfessionalData from '../screens/SignUp/Professional/Data';
import ProfessionalProfile from '../screens/SignUp/Professional/Profile';
import ProfessionalContact from '../screens/SignUp/Professional/Contact';
import ProfessionalSocial from '../screens/SignUp/Professional/Social';
import ProfessionalExperience from '../screens/SignUp/Professional/Experience';
import ProfessionalIdentity from '../screens/SignUp/Professional/Identity';
import SignUpVisitor from '../screens/SignUp/Visitor';
import VisitorData from '../screens/SignUp/Visitor/Data';
import DashboardContact from '../screens/Dashboard/Contact';
import DashboardPublic from '../screens/Dashboard/Public';
import DashboardProfile from '../screens/Dashboard/Profile';
import DashboardLogins from '../screens/Dashboard/Logins';
import DashboardExperience from '../screens/Dashboard/Experience';
import Search from '../screens/Search';
import PasswordForgot from '../screens/Password/Forgot';
import PasswordReset from '../screens/Password/Reset';
import DashboardFavorites from '../screens/Dashboard/Favorites';
import DashboardFavoriteList from '../screens/Dashboard/Favorites/FavoriteList';
export var RoutePaths;
(function (RoutePaths) {
    RoutePaths["SIGN_IN"] = "/sign-in";
    RoutePaths["SIGN_IN_SITUATION"] = "/sign-in/situation";
    RoutePaths["SIGN_UP_VISITOR"] = "/sign-up/visitor";
    RoutePaths["SIGN_UP_PROFESSIONAL"] = "/sign-up/professional";
    RoutePaths["SIGN_UP_PROFILE"] = "/sign-up/professional/profile";
    RoutePaths["SIGN_UP_CONTACT"] = "/sign-up/professional/contact";
    RoutePaths["SIGN_UP_SOCIAL"] = "/sign-up/professional/social";
    RoutePaths["SIGN_UP_EXPERIENCE"] = "/sign-up/professional/experience";
    RoutePaths["SIGN_UP_IDENTITY"] = "/sign-up/professional/identity";
    RoutePaths["DASHBOARD"] = "/";
    RoutePaths["DASHBOARD_PROFILE"] = "/profile";
    RoutePaths["DASHBOARD_CONTACT"] = "/contact";
    RoutePaths["DASHBOARD_LOGIN_DETAILS"] = "/logins";
    RoutePaths["DASHBOARD_EXPERIENCE"] = "/experiences";
    RoutePaths["DASHBOARD_FAVORITES"] = "/favorites";
    RoutePaths["DASHBOARD_FAVORITES_LIST"] = "/favorites/:listId";
    RoutePaths["STYLESHEET"] = "/stylesheet";
    RoutePaths["SEARCH"] = "/";
    RoutePaths["PASSWORD_FORGOT"] = "/password-forgot";
    RoutePaths["PASSWORD_RESET"] = "/password-reset";
    RoutePaths["BOOKMARKS"] = "/annuaire/#/favoris";
})(RoutePaths || (RoutePaths = {}));
export var routes = [
    {
        path: RoutePaths.DASHBOARD,
        element: (<RequireAuth>
        <Dashboard />
      </RequireAuth>),
        children: [
            {
                index: true,
                element: <DashboardPublic />,
            },
            {
                path: RoutePaths.DASHBOARD_PROFILE,
                element: <DashboardProfile />,
            },
            {
                path: RoutePaths.DASHBOARD_CONTACT,
                element: <DashboardContact />,
            },
            {
                path: RoutePaths.DASHBOARD_LOGIN_DETAILS,
                element: <DashboardLogins />,
            },
            {
                path: RoutePaths.DASHBOARD_FAVORITES,
                element: <DashboardFavorites />,
            },
            {
                path: RoutePaths.DASHBOARD_FAVORITES_LIST,
                element: <DashboardFavoriteList />,
            },
        ],
    },
    {
        path: RoutePaths.DASHBOARD_EXPERIENCE,
        element: (<RequireAuth>
        <DashboardExperience />
      </RequireAuth>),
    },
    {
        path: RoutePaths.SIGN_IN,
        element: (<RequireAnonymous>
        <SignIn />
      </RequireAnonymous>),
        children: [
            {
                index: true,
                element: <SignInForm />,
            },
            {
                path: RoutePaths.SIGN_IN_SITUATION,
                element: <SignInSituation />,
            },
        ],
    },
    {
        path: RoutePaths.SIGN_UP_PROFESSIONAL,
        element: (<RequireAnonymous>
        <SignUpProfessional />
      </RequireAnonymous>),
        children: [
            {
                index: true,
                element: <ProfessionalData />,
            },
            {
                path: RoutePaths.SIGN_UP_PROFILE,
                element: <ProfessionalProfile />,
            },
            {
                path: RoutePaths.SIGN_UP_CONTACT,
                element: <ProfessionalContact />,
            },
            {
                path: RoutePaths.SIGN_UP_SOCIAL,
                element: <ProfessionalSocial />,
            },
            {
                path: RoutePaths.SIGN_UP_EXPERIENCE,
                element: <ProfessionalExperience />,
            },
            {
                path: RoutePaths.SIGN_UP_IDENTITY,
                element: <ProfessionalIdentity />,
            },
        ],
    },
    {
        path: RoutePaths.SIGN_UP_VISITOR,
        element: (<RequireAnonymous>
        <SignUpVisitor />
      </RequireAnonymous>),
        children: [
            {
                index: true,
                element: <VisitorData />,
            },
        ],
    },
    {
        path: RoutePaths.PASSWORD_FORGOT,
        element: <PasswordForgot />,
    },
    {
        path: RoutePaths.PASSWORD_RESET,
        element: <PasswordReset />,
    },
];
export var searchRoutes = [
    {
        path: RoutePaths.SEARCH,
        element: <Search />,
    },
];
